import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/homepage/Layer_x0020_1.png")